import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PaiuLeadComponent} from '../paiu-lead/paiu-lead.component';
import {PaiuTransactionComponent} from './paiu-transaction.component';

const routes: Routes = [
    {
        path: 'paiu-transaction',
        component: PaiuTransactionComponent,
        data: {animation: 'paiu-transaction'}
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaiuTransactionRoutingModule { }
